import { render, staticRenderFns } from "./PlantLPG.vue?vue&type=template&id=4db956c6"
import script from "./PlantLPG.vue?vue&type=script&lang=js"
export * from "./PlantLPG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports